//eslint-disable-next-line
export const getCleanedObject = (obj: Record<string, any>) => {
  const copy = { ...obj };
  const keysToDelete: string[] = [];
  Object.keys(copy).forEach((key) => {
    if (
      obj[key] === '' ||
      obj[key] === null ||
      obj[key] === undefined ||
      (Array.isArray(obj[key]) && !obj[key].length)
    ) {
      keysToDelete.push(key);
    }
  });
  keysToDelete.forEach((key) => {
    delete copy[key];
  });
  return copy;
};
